import Spacer from '@/components/cms/Spacer';

const SpacerWrapper = ({ blok }) => <Spacer {...blok} />;
export default SpacerWrapper;
